import { render } from "./SuppliersPage.vue?vue&type=template&id=6ff23ac7&ts=true"
import script from "./SuppliersPage.ts?vue&type=script&lang=ts"
export * from "./SuppliersPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__